export enum MemberStatus {
    ACTIVE = "ACTIVE",
    INVITED = "INVITED",
    DECLINED = "DECLINED",
    EXPIRED_BY_SELF = "EXPIRED_BY_SELF",
    EXPIRED_BY_SYSTEM = "EXPIRED_BY_SYSTEM"
}

export enum MemberMenuAccessRole {
    ROLE_SKILL_CERTIFY = "ROLE_SKILL_CERTIFY",
    ROLE_SKILL_MONITOR = "ROLE_SKILL_MONITOR",
    ROLE_ADAPTIVE_LECTURE = "ROLE_ADAPTIVE_LECTURE",
}